import TrustlyInfoCard from "@/app/(general-header)/subscription-checkout/TrustlyInfoCard";
import { getTrustlyBillingDates } from "@/app/(general-header)/subscription-checkout/trustly-bonus-utils";

interface HowBillingWorksCardProps {
  billingDates: ReturnType<typeof getTrustlyBillingDates>;
  formattedPrice: string;
  showMembershipBadge: boolean;
  fullWidth?: boolean;
}

export default function HowBillingWorksCard({
  billingDates,
  formattedPrice,
  showMembershipBadge,
  fullWidth = false,
}: HowBillingWorksCardProps) {
  return (
    <div className={`min-w-0 w-full ${fullWidth ? "max-w-none" : ""}`}>
      <TrustlyInfoCard title="How billing works" bodyClassName={showMembershipBadge ? "gap-2" : "gap-1"}>
        <div className="flex flex-col gap-1 w-full">
          <div className="min-w-0 text-sm lg:text-base leading-5 lg:leading-[22px] font-medium text-dark-1 break-words">
            Pay your first month today
          </div>
          <div className="min-w-0 text-xs lg:text-[13px] leading-4 lg:leading-[18px] font-normal text-gray-1 break-words">
            Covers your {billingDates.membershipMonth} membership. Then {formattedPrice} via Direct Debit from{" "}
            {billingDates.directDebitStartFormatted}.
          </div>
        </div>
        {showMembershipBadge && (
          <div className="flex items-center gap-2.5 w-fit max-w-full px-2 py-1 bg-[#ffe1c2] border border-black/8 rounded">
            <span aria-hidden="true" className="size-2 shrink-0 rounded-full bg-primary" />
            <span className="text-xs lg:text-[13px] leading-4 lg:leading-[18px] font-normal text-[#8c4800] break-words">
              Membership starts {billingDates.paidSubscriptionStartFormatted}
            </span>
          </div>
        )}
      </TrustlyInfoCard>
    </div>
  );
}
